<template>
  <div>
    <button class="button barLocationButton" @click="toggleBarLocation">
      <span class="tooltip">{{ barOnTop ? 'Move Bar to Bottom' : 'Move Bar to Top'}}</span>
      <i class="material-icons">swap_vert</i>
    </button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState([
      'barOnTop'
    ])
  },
  methods: {
    ...mapMutations([
      'toggleBarLocation'
    ])
  }
}
</script>

<style>

</style>